import { useEffect, useState } from "react"
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2'
import { toast } from 'react-toastify';

export const useActions = ({
    //------------- Generales
    marvarApi, dispatch, user, onLogout, location, paramsURL, toggle, parseNumber,
    FetchData,

    defaultData,
    Helpers,
    
    //------------- Forms
    Forms,
    
    globalStates

})=>{

    const openModal = (_, title, compont, dataRequest) => {
        toggle(_, title, compont, dataRequest)
    }
    
    const closeModal = () => {
        toggle()
    }

    const handleChangeTypeCurrency = (event) => {

        //HOOKS
        const {FormDeposit} = Forms
        const {setFormState, formState} = FormDeposit
        const {deposito_monto, deposito_tipo_cambio} = formState
        
        const { name, value } = event.target

        //Verificamos si tiene data
        const monto = deposito_monto !== '' ? deposito_monto : 0;
        const tipo_cambio = deposito_tipo_cambio !== '' ? deposito_tipo_cambio : 0;

        if (value === 'DOLAR') {
            setFormState(prevState => ({
                ...prevState,
                [ name ]: value,
                deposito_quetzales : (monto*tipo_cambio),
                deposito_dolares : (monto),
            }))
        }else if (value === 'QUETZAL') {
            setFormState(prevState => ({
                ...prevState,
                [ name ]: value,
                deposito_quetzales : (monto),
                deposito_dolares : (monto/tipo_cambio),
            }))
        }
    }

    const handleChangeAmount = (event) => {
        
        const { name, value } = event.target

        const {FormDeposit} = Forms
        const {setFormState, formState} = FormDeposit
        const {deposito_tipo_cambio} = formState

        const valueParsed = parseNumber.setNumberMask(value)
        

        //Verificamos si tiene data
        const monto = valueParsed.value !== '' ? valueParsed.value : 0;
        const tipo_cambio = deposito_tipo_cambio !== '' ? deposito_tipo_cambio : 0;

        if (formState.deposito_moneda === 'DOLAR') {
            setFormState(prevState => ({
                ...prevState,
                [ name ]: valueParsed.value,
                [`${name}_mask`]: valueParsed.value_mask,
                deposito_quetzales : (monto*tipo_cambio),
                deposito_dolares : (monto),
            }))
        }else if (formState.deposito_moneda === 'QUETZAL') {
            setFormState(prevState => ({
                ...prevState,
                [ name ]: valueParsed.value,
                [`${name}_mask`]: valueParsed.value_mask,
                deposito_quetzales : (monto),
                deposito_dolares : (monto/tipo_cambio),
            }))
        }else {
            setFormState(prevState => ({
                ...prevState,
                [ name ]: valueParsed.value,
                [`${name}_mask`]: valueParsed.value_mask
            }))
        }
    }

    const handleChangeExchangeRate = (event) => {

        //HOOKS
        const {FormDeposit} = Forms
        const {setFormState, formState} = FormDeposit
        const {deposito_monto} = formState
        
        const { name, value } = event.target

        //Verificamos si tiene data
        const monto = deposito_monto !== '' ? deposito_monto : 0;
        const tipo_cambio = value !== '' ? value : 0;

        if (formState.deposito_moneda === 'DOLAR') {
            setFormState(prevState => ({
                ...prevState,
                [ name ]: value,
                deposito_quetzales : (monto*tipo_cambio),
                deposito_dolares : (monto),
            }))
        }else if (formState.deposito_moneda === 'QUETZAL') {
            setFormState(prevState => ({
                ...prevState,
                [ name ]: value,
                deposito_quetzales : (monto),
                deposito_dolares : (monto/tipo_cambio),
            }))
        }else {
            setFormState(prevState => ({
                ...prevState,
                [ name ]: value
            }))
        }
    }
   

    const handleClickShowModal = (_, title, compont, dataRequest, modalOpeningMode) => {
        const {setModalOpeningMode} = globalStates
        setModalOpeningMode(modalOpeningMode)
        openModal(_, title, compont, dataRequest)
    }


    const handleClickShowModalExpenses = (_, title, compont, dataRequest, idexpense) => {

        const { FormExpenses } = Forms
        const { formState, setFormState, onResetForm } = FormExpenses

        const { fetchInfoExtraExpenses } = FetchData

        const temp_idcontrato = formState.idcontrato 
        onResetForm()

        setFormState(prevState => ({
            ...prevState,
            idcontrato: temp_idcontrato 
        }))

        fetchInfoExtraExpenses.setParamsToSearch({idexpense: idexpense})
        fetchInfoExtraExpenses.executeFetchInfoExtraExpenses()

        openModal(_, title, compont, dataRequest)
    }

    const handleClickCloseModal = () => {
        
        //HOOKS
        const { FormDeposit, FormExpenses } = Forms
        const onResetFormDeposit  = FormDeposit.onResetForm
        const onResetFormExpenses  = FormExpenses.onResetForm
        
        onResetFormDeposit()
        onResetFormExpenses()
        closeModal()
    }

    const handleClickShowForm = (openingMode) => {
        const { setShowForm, setFormOpeningMode} = globalStates
        setFormOpeningMode(openingMode)
        setShowForm(true)
    }

    const handleClickHideForm = () => {

        const {setShowForm, setStepApplilication} = globalStates
        
        const { FormLeases, FormFiles, FormDeposit } = Forms
        const onResetFormLeases = FormLeases.onResetForm
        const onResetFormFiles = FormFiles.onResetForm
        const onResetFormDeposit = FormDeposit.onResetForm

        onResetFormLeases()
        onResetFormFiles()
        onResetFormDeposit()

        setStepApplilication(0)
        setShowForm(false)
    }

    const handleClickCompleteRequest = () => {

        const {setShowForm, setStepApplilication} = globalStates
        
        const { FormLeases, FormFiles, FormDeposit } = Forms
        const onResetFormLeases = FormLeases.onResetForm
        const onResetFormFiles = FormFiles.onResetForm
        const onResetFormDeposit = FormDeposit.onResetForm

        const { fetchAllLeaseContracts:{executeFetchAllLeaseContracts} } = FetchData


        onResetFormLeases()
        onResetFormFiles()
        onResetFormDeposit()

        executeFetchAllLeaseContracts()
        setStepApplilication(0)
        setShowForm(false)
    }

    const handleClickReturnStep = () => {
        const { stepApplilication, setStepApplilication} = globalStates
        setStepApplilication(stepApplilication-1)
    }

    const handleClickNextStep = () => {
        const { stepApplilication, setStepApplilication} = globalStates
        setStepApplilication(stepApplilication+1)
    }

    const handleClickFetchAllLeases = async () => {

        const { fetchAllLeaseApplications } = FetchData
        const { executeFetchAllLeaseApplications } = fetchAllLeaseApplications

        executeFetchAllLeaseApplications()

    }

    const handleClickFetchInfoLease = async (idcontrato) => {
        
        const { FormLeases} = Forms
        const { onResetForm } = FormLeases

        const { fetchInfoLease, fetchAllFiles, fetchAllDeposits, fetchAllObservations } = FetchData

        // Reseteamos el formulario para limpiar cualquier rastro de una busqueda anterior
        onResetForm()
        
        // Seteamos los parametros para filtrar info y ejecutamos el fetch
        fetchInfoLease.setParamsToSearch({idcontrato: idcontrato})
        fetchInfoLease.executeFetchInfoLease()
        
        fetchAllObservations.setParamsToSearch({idcontrato: idcontrato})
        fetchAllObservations.executeFetch()
        
        fetchAllFiles.executeFetchAllFiles()
        fetchAllDeposits.executeFetchAllDeposits()

        // setParamsToSearchDeposit({idcontrato: idcontrato})

        handleClickShowForm('READONLY')

    }

    const handleClickShowExpenses = async (idcontrato) => {
        
        const {setShowFormExpenses} = globalStates

        const { FormExpenses } = Forms
        const { setFormState } = FormExpenses

        const { fetchAllExtraExpenses } = FetchData
        
        setFormState(prevState => ({
            ...prevState,
            idcontrato: idcontrato 
        }))

        fetchAllExtraExpenses.executeFetchAllExtraExpenses()
        setShowFormExpenses(true)

    }

    const handleClickCloseExpenses = async () => {

        const {setShowFormExpenses} = globalStates
        const { FormExpenses } = Forms
        const { onResetForm } = FormExpenses
        
        onResetForm()
        setShowFormExpenses(false)
    }

    const handleClickFetchInfoDeposit = async (iddeposit) => {
        
        const { FormDeposit } = Forms
        const { onResetForm } = FormDeposit


        const { fetchInfoDeposit } = FetchData
        const { setParamsToSearch, executeFetchInfoDeposit } = fetchInfoDeposit

        // Reseteamos el formulario para limpiar cualquier rastro de una busqueda anterior
        onResetForm()
        
        // Seteamos los parametros para filtrar info y ejecutamos el fetch
        setParamsToSearch({iddeposit: iddeposit})
        executeFetchInfoDeposit()

        // setParamsToSearchDeposit({idcontrato: idcontrato})

        handleClickShowModal('', 'Formulario de depositos', 'deposits-section', {}, 'READONLY')

    }

    const handleClickEditLease = async (idcontrato) => {
        
        const { FormLeases } = Forms
        const { onResetForm } = FormLeases

        const { fetchInfoLease, fetchAllFiles, fetchAllDeposits, fetchAllObservations } = FetchData

        // Reseteamos el formulario para limpiar cualquier rastro de una busqueda anterior
        onResetForm()
        
        // Seteamos los parametros para filtrar info y ejecutamos el fetch
        fetchInfoLease.setParamsToSearch({idcontrato: idcontrato})
        fetchInfoLease.executeFetchInfoLease()

        fetchAllObservations.setParamsToSearch({idcontrato: idcontrato})
        fetchAllObservations.executeFetch()
        
        fetchAllFiles.executeFetchAllFiles()
        fetchAllDeposits.executeFetchAllDeposits()

        // setParamsToSearchDeposit({idcontrato: idcontrato})

        handleClickShowForm('EDITABLE')

    }

    
    const handleChangeHouses = (event) => {
        const { FormLeases } = Forms
        const { setFormState } = FormLeases

        const houses = JSON.parse(event.target.value || null)


        if(houses){
            setFormState(prevState => ({
                ...prevState,
                [event.target.name]: event.target.value,
                contrato_costo_alquiler: (houses.costo_alquiler==='') ? 0 : houses.costo_alquiler
            }))
        }else{
            setFormState(prevState => ({
                ...prevState,
                contrato_costo_alquiler: ''
            }))
        }
    }

    const handleClickCleanUpFiles = (event) => {
        const { FormFiles } = Forms
        const { setFormState } = FormFiles

        const { fetchAllDeposits } = FetchData
        const { executeFetchAllDeposits } = fetchAllDeposits

        setFormState(prevState => ({
            ...prevState,
            fileRejections: [],
            acceptedFiles: []
        }))

        executeFetchAllDeposits()

    }

    const handleClickDeleteDocument = (iddocumento) => {

        const { FormLeases:{ formState } } = Forms


        const { fetchAllFiles, fetchInfoLease} = FetchData
        const { executeFetchAllFiles } = fetchAllFiles
        const { setParamsToSearch, executeFetchInfoLease } = fetchInfoLease

        Swal.fire({
            title: '¿Desea eliminar este registro?',
            showConfirmButton: true,
            showCancelButton: true,
            confirmButtonText: 'Eliminar',
            cancelButtonText: 'Cancelar'
        }).then(async result => {
            if (result.isConfirmed) {
                await marvarApi.delete(`/leases/common/delete-document/${iddocumento}`)
                .then( async ({ data }) => {
                    alertMessage(data)
                    if (data.title === 'OK') {
                        await marvarApi.put(`/leases/common/aprobacion-check/${formState.idcontrato}`, {aprobacion_check: 'Pendiente Contrato', aprobacion_usuario: 'dmarroquin'})
                                .then(({ data }) => {
                                    setParamsToSearch({idcontrato: formState.idcontrato})
                                    executeFetchInfoLease()
                                })
                                .catch(error => {
                                    console.log('API ERROR: ', error)
                                })
                        executeFetchAllFiles()
                    }
                }).catch(error => {
                    console.log('API ERROR: ', error)
                })
            }
        })
    }

  
    const handleChangeTotalMonths = (event) => {
        
        const { name, value } = event.target

        const { FormLeases } = Forms
        const { formState ,setFormState } = FormLeases

        const totalAlquiler = (formState.contrato_costo_alquiler * (value || 0))
        const totalParsed = parseNumber.setNumberMask(String(totalAlquiler) || '0')
        
        setFormState({
            ...formState,
            [ name ]: value,
            contrato_total_alquiler: totalParsed.value,
            contrato_total_alquiler_mask: totalParsed.value_mask
        });
    }

    const handleClickUpdateAprobacion = async () => {

        const { FormLeases:{ formState } } = Forms


        const { fetchAllLeaseApplications} = FetchData
        const { executeFetchAllLeaseApplications } = fetchAllLeaseApplications

        await marvarApi.put(`/leases/common/aprobacion-check/${formState.idcontrato}`, {aprobacion_check: formState.aprobacion_check, aprobacion_usuario: 'dmarroquin', aprobacion_observaciones : formState.aprobacion_observaciones})
        .then(({ data }) => {
            alertMessage(data)
            executeFetchAllLeaseApplications()
            handleClickHideForm()
        })
        .catch(error => {
            console.log('API ERROR: ', error)
        })
    }

    const handleClickDownloadImage = async ( customFileName, openUrl) => {
        
        try {
            const response = await fetch(openUrl);
            const blob = await response.blob();
      
            // Crear un enlace temporal
            const enlaceTemporal = document.createElement('a');
            enlaceTemporal.href = window.URL.createObjectURL(blob);
            enlaceTemporal.download = customFileName; // Puedes cambiar el nombre del archivo
            document.body.appendChild(enlaceTemporal);
      
            // Simular clic en el enlace para iniciar la descarga
            enlaceTemporal.click();
      
            // Eliminar el enlace temporal
            document.body.removeChild(enlaceTemporal);
            
            toast.success('Se ha descargado la imagen');

          } catch (error) {
            console.error('Error al descargar la imagen', error);
          }

    }

    const handleClickDeleteExtraExpenses = (idexpense) => {

        const {fetchAllExtraExpenses} = FetchData
        const {executeFetchAllExtraExpenses} = fetchAllExtraExpenses

        Swal.fire({
            title: '¿Desea eliminar este registro?',
            showConfirmButton: true,
            showCancelButton: true,
            confirmButtonText: 'Eliminar',
            cancelButtonText: 'Cancelar'
        }).then(async result => {
            if (result.isConfirmed) {
                await marvarApi.delete(`/leases/common/delete-extra-expenses/${idexpense}`)
                .then( ({ data }) => {
                    alertMessage(data)
                    if (data.title === 'OK') {
                        executeFetchAllExtraExpenses()
                        // closeModal()
                    }else{
                        
                    }
                }).catch(error => {
                    console.log('API ERROR: ', error)
                })
            }
        })
    }

    const handleClickOpenTransactionsModal = async (_, title, compont, dataRequest, flagModalOpeningMode) => {

        const { fetchTransactionsByExpense } = FetchData
        const { setModalOpeningMode } = globalStates

        // console.log('[useActions][handleClickOpenTransactionsModal] dataRequest: ', dataRequest)
        // console.log('[useActions][handleClickOpenTransactionsModal] dataRequest.data: ', dataRequest.data)

        fetchTransactionsByExpense.setParamsToSearch({
            idexpense: dataRequest.idexpense
        })
        fetchTransactionsByExpense.executeFetch()

        
        setModalOpeningMode(flagModalOpeningMode)
        openModal(_, title, compont, dataRequest)
    }

    const handleClickShowTransactionForm = (flag, flagModalOpeningMode) => {

        // console.log({flag, flagModalOpeningMode})
        
        const { setShowTransactionsForm, setModalOpeningMode } = globalStates

        setShowTransactionsForm(flag)
        setModalOpeningMode(flagModalOpeningMode)

    }

    const handleClickHideTransactionForm = () => {

        const { FormExpenseTransaction } = Forms
        const { onResetForm } = FormExpenseTransaction

        onResetForm()
        handleClickShowTransactionForm(false)

    }

    const handleClickFetchAllTransactions = async (idexpense) => {

        const { fetchTransactionsByExpense, fetchAllExtraExpenses } = FetchData

        // Fetch para listar todos los movimientos
        fetchTransactionsByExpense.setParamsToSearch({
            idexpense: idexpense
        })
        fetchTransactionsByExpense.executeFetch()
        
        fetchAllExtraExpenses.executeFetchAllExtraExpenses()

    }

    const handleChangeTypeTransaction = async (e) => {

        const { FormExpenseTransaction } = Forms
        const { setFormState, } = FormExpenseTransaction

        const { name, value } = e.target


        setFormState(prevState => ({
            ...prevState,
            // efectivo
            idcaja: '',
            deposito_observaciones: '',
            // deposito
            boleta_numero: '',
            idbanco: '',
            aprobacion_referencia_ach: '',
            aprobacion_check: '',
            aprobacion_observaciones: '',
            acceptedFiles: [],
            fileRejections: [],
            [ name ]: value
        }))
    }

    const _calculateTotalQuetzalsAndDollars = async ({refSetFormState, movimiento_monto, movimiento_moneda, movimiento_tipo_cambio}) => {
        switch(movimiento_moneda){
            case 'QUETZAL':
                refSetFormState(prevState => ({
                    ...prevState,
                    movimiento_quetzales: parseFloat(movimiento_monto).toFixed(2) || '', // Valor predeterminado si es indefinido
                    movimiento_dolares: parseFloat(movimiento_monto / movimiento_tipo_cambio).toFixed(2) || '', // Valor predeterminado si es indefinido
                }))
            break
            case 'DOLAR':
                refSetFormState(prevState => ({
                    ...prevState,
                    movimiento_quetzales: parseFloat(movimiento_monto * movimiento_tipo_cambio).toFixed(2) || '', // Valor predeterminado si es indefinido
                    movimiento_dolares: parseFloat(movimiento_monto).toFixed(2) || '', // Valor predeterminado si es indefinido
                }))
            break
            default:
                console.log(`No se reconoce la selección: ${movimiento_moneda}`)
            break
        }
    }

    const handleChangeExpenseAmount = (event) => {
        const { name, value } = event.target
        
        const { FormExpenseTransaction } = Forms
        const { formState, setFormState } = FormExpenseTransaction

        const valueParsed = parseNumber.setNumberMask(value)

        setFormState(prevState => ({
            ...prevState,
            [name ]: valueParsed.value,
            [`${name}_mask`]: valueParsed.value_mask
        }))

        if(formState.movimiento_moneda !== '' && formState.movimiento_tipo_cambio !== '') {
            _calculateTotalQuetzalsAndDollars({
                refSetFormState: setFormState,
                movimiento_monto: value,
                movimiento_moneda: formState.movimiento_moneda,
                movimiento_tipo_cambio: formState.movimiento_tipo_cambio
            })
        }

    }

    const handleChangeExpenseTypeCurrency = (event) => {
        const { FormExpenseTransaction } = Forms
        const { formState, setFormState } = FormExpenseTransaction

        const { name, value } = event.target
        setFormState(prevState => ({
            ...prevState,
            [name ]: value
        }))

        if(formState.movimiento_monto !== '' && formState.movimiento_tipo_cambio !== '') {
            _calculateTotalQuetzalsAndDollars({
                refSetFormState: setFormState,
                movimiento_monto: formState.movimiento_monto,
                movimiento_moneda: value,
                movimiento_tipo_cambio: formState.movimiento_tipo_cambio
            })
        }

    }

    const handleChangeExpenseExchangeRate = (event) => {
        const { FormExpenseTransaction } = Forms
        const { formState, setFormState } = FormExpenseTransaction

        const { name, value } = event.target
        setFormState(prevState => ({
            ...prevState,
            [name ]: value
        }))

        if(formState.movimiento_monto !== '' && formState.movimiento_moneda !== '') {
            _calculateTotalQuetzalsAndDollars({
                refSetFormState: setFormState,
                movimiento_monto: formState.movimiento_monto,
                movimiento_moneda: formState.movimiento_moneda,
                movimiento_tipo_cambio: value
            })
        }

    }

    const handleClickShowExpenseTransactionInfo = async (itemData, flagShowTransactionForm, flagModalOpeningMode) => {
        
        // console.log('[useAction][handleClickShowTransactionInfo] itemData: ', itemData)

        const { fetchSpecificExpenseTransaction } = FetchData 
        const { setModalOpeningMode } = globalStates
        const { FormExpenseTransaction } = Forms
        const { setFormState} = FormExpenseTransaction

        fetchSpecificExpenseTransaction.setParamsToSearch({
            idtransaction: itemData.idtransaction,
            fecthTransactionInfo: {
                flag: true,
                refSetFormState: setFormState
            }
        })
        fetchSpecificExpenseTransaction.executeFetch()

        handleClickShowTransactionForm(flagShowTransactionForm)
        setModalOpeningMode(flagModalOpeningMode)
    }

    const handleClickPrintDepositTicket = async (iddeposit) => {

        const { fetchInfoDeposit} = FetchData
        
        fetchInfoDeposit.setParamsToSearch({
            iddeposit: iddeposit,
            printTicketFlag: true
        })
        fetchInfoDeposit.executeFetchInfoDeposit()

    }
    
    const handleClickPrintExtraExpensesTicket = async (idtransaction) => {

        console.log('handleClickPrintExtraExpensesTicket ---- ', idtransaction)

        const { fetchSpecificExpenseTransaction } = FetchData
        
        fetchSpecificExpenseTransaction.setParamsToSearch({
            idtransaction: idtransaction,
            printTicketFlag: true
        })
        fetchSpecificExpenseTransaction.executeFetch()

    }

    const onSubmitFormApplies = async (e) => {

        e.preventDefault()

        //HOOKS
        const { fetchAllFiles:{executeFetchAllFiles} } = FetchData
        
        executeFetchAllFiles()
        handleClickNextStep()

    }

    const onSubmitFormFiles = async (e) => {

        e.preventDefault()
      
        const { FormFiles, FormLeases } = Forms
        const { formState, setFormState } = FormFiles
        const formStateLeases = FormLeases.formState

        const {fetchAllFiles} = FetchData
        const {executeFetchAllFiles} = fetchAllFiles
        
        if(formState.acceptedFiles.length<=0){
            Swal.fire({
                icon: 'error',
                title: 'ERROR!!',
                text: 'Debe seleccionar al menos un documento para subir'
            })
            return
        }        

        if(formState.acceptedFiles.length>1){
            Swal.fire({
                icon: 'error',
                title: 'ERROR!!',
                text: 'Solo puede cargar 1 archivo'
            })
            return
        }   

        const _data = new FormData();

        _data.append('idcontrato', formStateLeases.idcontrato);
        _data.append('department', 'ADMINISTRACION');
        _data.append('usuario_creo', 'dmarroquin');
        _data.append('fecha_creo', new Date());


        formState.acceptedFiles.forEach((file, index) => {
            _data.append(`attachmentt`, file);
        });

        await marvarApi.post( `/leases/common/create-document`, _data )
        .then(async ({ data }) => {
            alertMessage(data)

            if (data.title === 'OK') {
                setFormState(prevState => ({
                    ...prevState,
                    acceptedFiles : [],
                    fileRejections : []
                }))
                executeFetchAllFiles()
            }
        })
        .catch(error => {
            console.log('API ERROR: ', error)
        })
    }

    const onSubmitFormDeposits = async (e) => {

        e.preventDefault()
    
        const { FormDeposit, FormLeases } = Forms
        const { formState, onResetForm } = FormDeposit
        const formStateLeases = FormLeases.formState
    
        const {fetchAllDeposits} = FetchData
        const {executeFetchAllDeposits} = fetchAllDeposits
        
        const body = {
            aprobacion_check: formState.aprobacion_check,
            aprobacion_referencia_ach : formState.aprobacion_referencia_ach,
            aprobacion_observaciones : formState.aprobacion_observaciones,
            aprobacion_usuario: user.username
        }
        
        if(formState.movimiento_tipo==='DEPOSITO'){
        
            await marvarApi.put( `/leases/common/aprobacion-check-deposit/${formState.iddeposit}`, body )
            .then(({ data }) => {

                alertMessage(data)

                if (data.title === 'OK') {
                    onResetForm()
                    executeFetchAllDeposits()
                    closeModal()
                }
                
            })
            .catch(error => {
                    console.log('API ERROR: ', error)
            })
    
        }else{
            closeModal()
        }

    }

    const onSubmitFormExpenses = async (e) => {

        e.preventDefault()

        const { FormExpenses } = Forms
        const { formState, onResetForm, setFormState } = FormExpenses
        
        const { getCurrentDate } = Helpers
    
        const { fetchAllExtraExpenses } = FetchData
        const { executeFetchAllExtraExpenses } = fetchAllExtraExpenses

        const isForUpdate = (formState.idexpense>0)
        const usuarioField =isForUpdate ? 'usuario_modifico' : 'usuario_creo';
        const fechaField =isForUpdate ? 'fecha_modifico' : 'fecha_creo';

        if (formState.info_fecha_pago === '') {
            Swal.fire({
                icon: 'error',
                title: 'ERROR!!',
                text: 'No ha especificado una fecha'
            })
            return
        }
        
        if (formState.info_costo === '') {
            Swal.fire({
                icon: 'error',
                title: 'ERROR!!',
                text: 'No ha especificado el costo'
            })
            return
        }
        
        if (formState.info_descripcion === '') {
            Swal.fire({
                icon: 'error',
                title: 'ERROR!!',
                text: 'No ha especificado una descripción'
            })
            return
        }

        const body = {
            idexpense: formState.idexpense,
            idcontrato: formState.idcontrato,
            info_descripcion:formState.info_descripcion ,
            info_fecha_pago:formState.info_fecha_pago ,
            info_costo:formState.info_costo ,
            [ usuarioField ]: user.username,
            [ fechaField ]: getCurrentDate(),
        }

        console.log('[useActions][onSubmitFormExpenses] body: ', body)

        if(isForUpdate){
            await marvarApi.put( `/leases/common/update-extra-expense/${formState.idexpense}`, body )
                .then(({ data }) => {
        
                    alertMessage(data)
        
                    if (data.title === 'OK') {
                        const temp_idcontrato = formState.idcontrato 
                        onResetForm()
        
                        setFormState(prevState => ({
                            ...prevState,
                            idcontrato: temp_idcontrato 
                        }))
                        executeFetchAllExtraExpenses()
                        closeModal()
                    }
                    
                })
            .catch(error => {
                    console.log('API ERROR: ', error)
                })
        }else{
            await marvarApi.post( `/leases/common/save-extra-expense`, body )
            .then(({ data }) => {
    
                alertMessage(data)
    
                if (data.title === 'OK') {
                    const temp_idcontrato = formState.idcontrato 
                    onResetForm()
    
                    setFormState(prevState => ({
                        ...prevState,
                        idcontrato: temp_idcontrato 
                    }))
                    executeFetchAllExtraExpenses()
                    closeModal()
                }
                
            })
            .catch(error => {
                console.log('API ERROR: ', error)
            })
        }

    
    }

    const onSubmitExpenseTransaction = async (e, idexpense, idcontrato) => {
    
        e.preventDefault()

        const { FormExpenseTransaction } = Forms
        const { formState, onResetForm } = FormExpenseTransaction

        const { fetchSpecificExpenseTransaction } = FetchData

        // Determina si se hace un pago en "efectivo" para confirmar que se incluya información de la caja que recibirá el dinero
        if(formState.movimiento_tipo === 'EFECTIVO' && formState.idcaja === ''){
            Swal.fire({
                icon: 'error',
                title: 'Información incompleta',
                text: 'Se ha indicado que se registrará pago en "efectivo" pero no ha especificado la "caja" que recibe el dinero'
            })
            return;
        }

        // Determina si se hace un "deposito" para confirmar que se incluya información de la boleta
        if(formState.movimiento_tipo === 'DEPOSITO' && formState.boleta_numero ===''){
            Swal.fire({
                icon: 'error',
                title: 'Información incompleta',
                text: 'Se ha indicado que se registrará un "deposito" pero no ha especificado el "número de boleta"'
            })
            return;
        }

        // Determina si se hace un "deposito" para confirmar que se incluya información de la boleta
        if(formState.movimiento_tipo === 'DEPOSITO' && formState.idbanco ===''){
            Swal.fire({
                icon: 'error',
                title: 'Información incompleta',
                text: 'Se ha indicado que se registrará un "deposito" pero no ha especificado el "banco"'
            })
            return;
        }

        // Determina si se hace un "deposito" para confirmar que se incluya información de la boleta
        if(formState.movimiento_tipo === 'DEPOSITO' && formState.acceptedFiles.length<=0){
            Swal.fire({
                icon: 'error',
                title: 'Información incompleta',
                text: 'Se ha indicado que se registrará un "deposito" pero no ha especificado una "foto", o no ha seleccionado una foto valida'
            })
            return;
        }

        const _data = new FormData();
        _data.append('idexpense', idexpense);
        _data.append('idcaja', formState.idcaja);
        _data.append('idbanco', formState.idbanco);
        _data.append('movimiento_usuario', user.username);
        _data.append('movimiento_fecha', formState.movimiento_fecha);
        _data.append('movimiento_tipo', formState.movimiento_tipo);
        _data.append('movimiento_monto', formState.movimiento_monto);
        _data.append('movimiento_moneda', formState.movimiento_moneda);
        _data.append('movimiento_tipo_cambio', formState.movimiento_tipo_cambio);
        _data.append('movimiento_quetzales', formState.movimiento_quetzales);
        _data.append('movimiento_dolares', formState.movimiento_dolares);
        _data.append('movimiento_observaciones', formState.movimiento_observaciones);
        _data.append('boleta_numero', formState.boleta_numero);
        _data.append('usuario_creo', user.username);
        _data.append('fecha_creo', new Date() );

        formState.acceptedFiles.forEach((file, index) => {
            _data.append(`images`, file);
        });

        await marvarApi.post( `/leases/common/save-expense-transaction`, _data )
            .then(({ data }) => {

                console.log('onSubmitExpenseTransaction ------ ', data)

                toast.success(data.message, {
                    position: "top-right",
                    theme: "colored",
                    autoClose: false,
                })

                onResetForm()
                handleClickFetchAllTransactions(idexpense, idcontrato)
                handleClickHideTransactionForm()

                if(data.flag === 'OK') {
                    fetchSpecificExpenseTransaction.setParamsToSearch({
                        idtransaction: data.rows[0].insertId,
                        printTicketFlag: true
                    })
                    fetchSpecificExpenseTransaction.executeFetch()
                }

            })
            .catch(error => {
                console.log('API ERROR: ', error)

                toast.warn(`Hubo un problema interno, detalles técnicos: ${error}`, {
                    position: "top-right",
                    theme: "colored",
                    autoClose: false,
                })

                onResetForm()
                handleClickFetchAllTransactions(idexpense, idcontrato)
                handleClickHideTransactionForm()
            })

    }

    const onSubmitObservationsForm = async (e) => {
    
        e.preventDefault()

        // const { formOpeningMode } = globalStates
        
        const { ObservationsForm, FormLeases } = Forms

        const { fetchAllObservations } = FetchData

        console.log('[useActions][onSubmitObservationsForm] FormLeases.formState ::: ', FormLeases.formState)

        if (FormLeases.formState.idcontrato === '') {
            Swal.fire({
                icon: 'error',
                title: 'ERROR!!',
                text: 'No es posible guardar el comentario, no se puede identificar el contrato a asociar.'
            })
            return
        }

        if (ObservationsForm.formState.log_observacion === '') {
            Swal.fire({
                icon: 'error',
                title: 'ERROR!!',
                text: 'No a escrito nada para agregar como comentario, por favor, revise que su comentario este escrito.'
            })
            return
        }

        const _data = { 
            idcontrato: FormLeases.formState.idcontrato,
            // idcontrato: 3,
            log_departamento: 'GESTIONES',
            log_observacion: ObservationsForm.formState.log_observacion,
            idusuario: user.uid,
            user: user.username
        }

        console.log('[useActions][onSubmitObservationsForm] _data ::: ', _data)

        await marvarApi.post( `/leases/common/save-observation`, _data )
            .then(({ data }) => {

                alertMessage(data)

                fetchAllObservations.setParamsToSearch({
                    idcontrato: parseInt(FormLeases.formState.idcontrato, 10)
                    // idcontrato: parseInt(3, 10)
                })
                fetchAllObservations.executeFetch()

                ObservationsForm.onResetForm()

            }).catch(error => {console.log('API ERROR: ', error)})

    }


    return Object.freeze({
        handleChangeAmount,
        handleChangeExchangeRate,
        handleChangeHouses,
        handleChangeTotalMonths,
        handleChangeTypeCurrency,
        handleClickCleanUpFiles,
        handleClickCloseModal,
        handleClickCompleteRequest,
        handleClickDeleteDocument,
        handleClickEditLease,
        handleClickFetchInfoDeposit,
        handleClickFetchInfoLease,
        handleClickHideForm,
        handleClickNextStep,
        handleClickReturnStep,
        handleClickShowForm,
        handleClickShowModal,
        handleClickUpdateAprobacion,
        handleClickDownloadImage,
        handleClickShowExpenses,
        handleClickShowModalExpenses,
        handleClickCloseExpenses,
        handleClickDeleteExtraExpenses,
        handleClickOpenTransactionsModal,
        handleClickShowTransactionForm,
        handleClickHideTransactionForm,
        handleChangeTypeTransaction,
        handleChangeExpenseAmount,
        handleChangeExpenseTypeCurrency,
        handleChangeExpenseExchangeRate,
        handleClickShowExpenseTransactionInfo,
        handleClickPrintDepositTicket,
        handleClickPrintExtraExpensesTicket,
        onSubmitFormApplies,
        onSubmitFormFiles,
        onSubmitFormDeposits,
        onSubmitFormExpenses,
        onSubmitExpenseTransaction,
        onSubmitObservationsForm
    })
}

/**
 * Funcion para gestionar las alertas de toastify
 * @param {*} res : respuesta del API / custom (debe ser un json "{}")
 * @param {*} toggle : toggle de modal
 */
const alertMessage = (res, toggle) => {


    if (res) {
        const { title, message} = res
        if (title === 'OK') {
            toast.success(message, {
                position: "top-right",
                theme: "colored"
            })
            toggle && toggle()
        } else {
            toast.warn(message, {
                position: "top-right",
                theme: "colored",
                autoClose: false,
            })
        }
    } else {
        toast.warn('Error interno, notifique a Soporte técnico!.', {
            position: "top-right",
            theme: "colored",
            autoClose: false,
        })
    }
}